import { usePDFPrintHook } from "@careinfo/layout";
import { tw } from "@careinfo/tailwind";
import loadable from "@loadable/component";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import APIS from "../../constant/Endpoint";
import useGetHook from "../../customHooks/useGetHook";
import usePostHook from "../../customHooks/usePostHook";
import { postApiFormData } from "../../helpers/AxiosInstance";

const CreateJournalEntryComponent = loadable(
  () => import("../../components/JournalEntry/Create")
);

export default () => {
  const navigate = useNavigate();
  const { downloadPrint, isPrintLoading } = usePDFPrintHook();
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [openPrintPopup, setOpenPrintPopup] = useState(false);
  const { refetch: numbSeriresRefetch } = useGetHook({
    queryKey: ["number-serires-journal-entry"],
    url: APIS.NUMBER_SERIRES,
    params: {
      type: "Journal Voucher",
    },
  });
  const { refetch: entryNoRefetch } = useGetHook({
    queryKey: ["journal-entry"],
    url: APIS.JOURNAL_ENTRY,
    params: {
      type: "Journal Voucher",
      limit: 1,
      offset: 0,
    },
  });

  const [isLoading, setIsLoading] = useState(false);
  const queryClient = useQueryClient();
  const handleCreate = async (values: any, isDraft: any, setError: any) => {
    setIsLoading(true);
    const url = APIS.JOURNAL_ENTRY;
    const formData = new FormData();
    values?.voucher_date
      ? formData.append("voucher_date", values?.voucher_date)
      : null;
    formData.append("number_series", values?.number_series);
    formData.append("entry_number", values?.entry_number);
    formData.append("type", "Journal Voucher");
    if (values?.journal_account) {
      formData.append(
        "journal_account",
        JSON.stringify(values.journal_account)
      );
    }
    isDraft
      ? formData.append("status", "Draft")
      : formData.append("status", "Success");
    if (values?.attachment?.[0] && typeof values?.attachment !== "string") {
      formData.append("attachment", values?.attachment?.[0]);
    }
    values?.narration ? formData.append("narration", values?.narration) : null;
    try {
      const res = await postApiFormData({ url, formData, setError });
      if (res?.status === 201) {
        queryClient.invalidateQueries({
          queryKey: ["journal-entry"],
          refetchType: "active",
        });
        if (!isDraft) {
          setSelectedOrder(res?.data?.id);
          setOpenPrintPopup(true);
        } else {
          navigate("/accounting/journal-voucher");
        }
        toast.success("Create Successfully");
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["ledger-account"],
    navigateURL: "",
  });

  const handleCreateAccount = async (
    values: any,
    setOpenAccountPopup: any,
    setError: any
  ) => {
    const url = APIS.COA;
    const formData = {
      ...values,

      is_group: false,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 201) {
        setOpenAccountPopup(false);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handlePrint = async () => {
    const url = APIS.BILL_PRINT;
    let formData = {
      ids: [selectedOrder],
      type: "Journal Voucher",
    };

    try {
      const res = await downloadPrint(url, formData);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div>
      <div className={tw`flex items-center justify-between mb-2`}>
        <h1 className={tw`font-semibold text-2xl leading-8`}>
          Create Journal Voucher
        </h1>
      </div>

      <CreateJournalEntryComponent
        handleCreate={handleCreate}
        isLoading={isLoading}
        entryNoRefetch={entryNoRefetch}
        numbSeriresRefetch={numbSeriresRefetch}
        openPrintPopup={openPrintPopup}
        setOpenPrintPopup={setOpenPrintPopup}
        handlePrint={handlePrint}
        isPrintLoading={isPrintLoading}
        handleCreateAccount={handleCreateAccount}
        isPostLoading={isPostLoading}
      />
    </div>
  );
};
